import { Grid, Typography, IconButton, Popover } from "@mui/material";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import styled from "styled-components";

type SGridColumnExpandedProps = {
  $isExpanded: boolean;
  $isSuperExpanded?: boolean;
  $isSuperCarteira?: boolean;
};

export const SGridOuterContainer = styled(Grid)`
  && {
    overflow: scroll;
    height: ${({ theme }) =>
      theme.navbar.show ? "calc(100vh - 44px)" : "calc(100vh + 15px)"};

    &::-webkit-scrollbar {
      width: 10px;
      margin-top: -10%;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #d6d3d3;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-button:start:increment {
      height: 0%;
      display: block;
      background: transparent;
    }
  }
`;

export const SGridContainer = styled(Grid)<{
  $isSuperCarteira?: boolean;
  $isSuperExpanded?: boolean;
}>`
  && {
    display: flex;
    overflow-y: none;
    padding-left: ${({ $isSuperCarteira }) =>
      $isSuperCarteira ? "0px" : "32px"};
    position: relative;
    z-index: 1 !important;
  }
`;

export const SGridColumnLeft = styled(Grid)<SGridColumnExpandedProps>`
  && {
    background-color: ${({ theme }) => theme.colors.bgPrimary};
    display: ${({ $isSuperExpanded }) => ($isSuperExpanded ? "none" : "unset")};
    width: ${({ $isExpanded }) => ($isExpanded ? "50%" : "100%")};
    height: ${({ theme }) =>
      theme.navbar.show ? "calc(100vh - 15px - 84px)" : "calc(100vh - 15px)"};
    padding-left: ${({ $isSuperCarteira }) =>
      $isSuperCarteira ? "32px" : "0px"};
  }
`;

export const SGridColumnRight = styled(Grid)<SGridColumnExpandedProps>`
  && {
    background-color: ${({ theme }) => theme.colors.bgGray};
    min-width: 405px;
    max-width: ${({ $isExpanded, $isSuperExpanded }) => {
      if ($isSuperExpanded) return "unset";

      return $isExpanded ? "50%" : "405px";
    }};
    width: ${({ $isExpanded, $isSuperExpanded }) => {
      if ($isSuperExpanded) return "100%";

      return $isExpanded ? "50%" : "100%";
    }};
    height: ${({ theme }) =>
      theme.navbar.show ? "calc(100vh - 84px)" : "calc(100vh)"};
  }
`;

export const SSearchArea = styled(Grid)`
  && {
    width: 100%;
    padding-right: 32px;
  }
`;

export const STitle = styled(Typography)`
  && {
    color: ${({ theme }) => theme.colors.textDefault};
    font-family: ${({ theme }) => theme.fonts.primary};
    font-weight: 600;
    font-style: normal;
    font-size: 24px;
    line-height: 33px;
    margin-top: 24px;
    padding: 0;
  }
`;

export const SMessage = styled(Typography)`
  && {
    color: ${({ theme }) => theme.colors.textDefault};
    font-family: ${({ theme }) => theme.fonts.primary};
    font-weight: 400;
    font-style: normal;
    font-size: 16px;
    line-height: 22px;
    margin-top: 4px;
    padding-right: 32px;
    margin-bottom: 0px;
    width: 100%;
  }
`;

export const SGridLocaleFloatingMenu = styled(Grid)`
  && {
    position: absolute;
    top: 0px;
    right: 0;
    z-index: 9999;
  }
`;

type SGridQuantumBannerProps = {
  $isSuperExpanded: boolean;
};

export const SGridQuantumBanner = styled(Grid)<SGridQuantumBannerProps>`
  && {
    display: ${({ $isSuperExpanded }) => ($isSuperExpanded ? "none" : "unset")};
    width: 100%;
    margin-top: ${({ theme }) => (theme.navbar.show ? "-25px" : "0")};
    z-index: 9999;
    height: ${({ theme }) =>
      theme.navbar.show ? "calc(76px + 25px)" : "76px"};
  }
`;

export const SPopover = styled(Popover)`
  && {
    top: ${({ theme }) => (theme.navbar.show ? "58px" : "0px")};
  }
`;

export const SPopoverMessageContainer = styled(Grid)`
  && {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background-color: ${({ theme }) =>
      theme.colors.snackbarMessageError} !important;
    min-height: 58px;
    border-radius: 5px;
    padding: 8px;
    padding-right: 40px;
    padding-left: 30px;
  }
`;

export const SPopoverMessage = styled(Typography)`
  && {
    display: flex;
    align-items: center;
    width: 100%;
    grid-gap: 10px;
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.textWhite};
  }
`;

export const SClosePopoverButton = styled(IconButton)`
  && {
    position: absolute;
    top: -4px;
    right: -4px;
  }
`;

export const SClosePopoverIcon = styled(CancelRoundedIcon)`
  && {
    color: ${({ theme }) => theme.colors.textWhite};
    font-size: 20px;
  }
`;

export const ToggleButton = styled.button<{ $isExpanded: boolean }>`
  position: absolute;
  top: 20px;
  transform: ${({ $isExpanded }) =>
    $isExpanded ? "translateX(25%)" : "translateX(50%) rotate(180deg)"};
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: rgba(51, 51, 51, 0.6);
  color: rgb(255, 255, 255);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 9999;
  transition: left 0.3s ease;
  margin-left: ${({ $isExpanded }) => ($isExpanded ? "0px" : "-20px")};

  &:hover {
    background-color: rgb(37, 64, 87);
  }
`;
